import { css } from '@emotion/react';
import styledBP from '@emotion/styled';
import { styled } from '@zoopla-eng/zds-components/themes';

export const Layout = styled('main', {
    display: 'block',
    margin: '0 auto',

    '@M100': {
        padding: '0 $S400'
    },

    '@L100': {
        padding: '0 $M100',
        maxWidth: 'calc(1200px + $M100)'
    }
});

export const Adverts = styledBP('aside')(
    ({ theme: { mq, spacing } }) => css`
        display: none;
        width: 300px;
        margin-left: ${spacing['24px']};

        ${mq.large} {
            display: flex;
            flex-direction: column;
        }

        > div:first-of-type > div {
            margin-top: 0;
        }
    `
);

export const Sticky = styledBP('div')(css`
    position: sticky;
    top: 0;
    width: 100%;
    align-self: flex-start;
`);
